enum DecimalFormatType {
  TWO = 2,
  NONE = 0,
  MAERSK = 4,
  M3 = 2,
  FT3 = 0,
}

/**
 * function used to format decimal place of number with quantity predefined
 * @param formatType DecimalFormatType enum value with format type available
 * @example DecimalFormatType.NONE
 * @param value value in string or number that be used to format with decimal places
 * @param ifEmpty value to be returned if not have value, formatType or value sent not is a number value. Default = 0
 * @returns a value formatted with decimal places
 *
 * @example
 * const valueFormatted = formatDecimalValue(DecimalFormatType.NONE, 13.13, 0);
 * console.log(valueFormatted); // valueFormatted = 13
 */
const formatDecimalValue = (
  formatType: DecimalFormatType,
  value?: string | number,
  ifEmpty?: string | number
) => {
  // eslint-disable-next-line eqeqeq
  if ((!value && value != 0) || !formatType) return ifEmpty;

  const number = Number(value);

  if (Number.isNaN(number)) return ifEmpty;

  return number.toFixed(formatType);
};

export { DecimalFormatType, formatDecimalValue };
